import { Outlet } from "react-router-dom";
import NotFound from "../Views/Pages/Notfound";
import Logout from "../Views/Components/LogOut";
import IFrame from "../Views/Pages/IFrameAgent";
import IFrameMultiAgent from "../Views/Pages/IFrameMultiAgent";

const MaintenanceRoute = {
    element: (
        <>
            <Outlet />
        </>
    ),
    children: [
        {
            path: '*',
            element: <NotFound />
        },
        {
            path: '/logout',
            element: <Logout />
        },
        {
            path: '/iframeAgent/:agentId/:apiKey',
            element: <IFrame />
        },
         {
            path: '/iframeMultiAgent/:teamsId/:apiKey',
            element: <IFrameMultiAgent />
        },


    ]

}

export default MaintenanceRoute